import React, { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";
import Nav from "../components/Navbar";
import SEO from "../components/SEO";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

// Import Swiper CSS
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// External CSS
import "./PublicListing.css";

const PublicListing = () => {
  const { token } = useParams();
  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const BACKEND_URL = process.env.REACT_APP_API_URL;

  const API_URL = `${BACKEND_URL}/hotels/public-listing/${token}`;

  useEffect(() => {
    const fetchListing = async () => {
      try {
        const response = await axios.get(API_URL);
        setListing(response.data.data);
      } catch (err) {
        setError("Hotel Listing not found or expired!");
      } finally {
        setLoading(false);
      }
    };
    fetchListing();
  }, [token, API_URL]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error">{error}</p>;

  const hotelName = listing?.owner?.hotel?.name || "Hotel Stay";
  const packageName = listing?.name || "Room Package";
  const primaryImage = listing?.hotel_images?.[0]?.url || "https://soloway.lk/logo.png";
  const description = listing?.description || `Book ${packageName} at ${hotelName} in Sri Lanka with Soloway.`;

  const hotelSchema = {
    "@context": "https://schema.org",
    "@type": "Hotel",
    "name": hotelName,
    "description": description,
    "image": listing?.hotel_images?.map((img) => img.url) || [primaryImage],
    "priceRange": `LKR ${listing?.price || 0}`,
    "offers": {
      "@type": "Offer",
      "name": packageName,
      "price": listing?.price,
      "priceCurrency": "LKR",
      "availability": "https://schema.org/InStock",
      "url": `https://soloway.lk/public-listing/${token}`
    }
  };

  return (
    <>
        <SEO 
          title={`${hotelName} - ${packageName}`}
          description={description.substring(0, 160)}
          canonicalPath={`/public-listing/${token}`}
          ogImage={primaryImage}
          schemaJson={hotelSchema}
        />
        <Nav/>
        <div className="container">
        <h3 className="listing-title">Hotel Listing of {listing.owner.hotel.name} by {listing.owner.full_name}</h3>
        {listing.hotel_images?.length > 0 && (
            <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            >
            {listing.hotel_images.map((img, index) => (
                <SwiperSlide key={index}>
              <img
                src={img.url}
                alt={`Room view for ${listing.title || listing.name || "Stay"}`}
                style={{ width: "100%", height: "360px", objectFit: "cover", borderRadius: "12px" }}
            />
                </SwiperSlide>
            ))}
            </Swiper>
        )}

        <hr/>

        <h3>Package Details: </h3>
        <p className="hotel-label"><strong>Package Name:</strong> {listing.title || listing.name || "Stay Package"}</p>
        <p className="roomType"><strong>Room Type:</strong> {listing.room_type.name} room</p>
        <p className="maxGuests"><strong>Maximum Guests:</strong> {listing.max_guest} People</p>
        <p className="price-tag">LKR {listing.price} </p>
        <p className="description">{listing.description}</p>

        <hr/>

        {listing.amenities?.length > 0 && (
            <>
            <h3>Amenities:</h3>
            <div>
                {listing.amenities.map((a) => (
                <span key={a.id} className="amenity-badge">{a.name}</span>
                ))}
            </div>
            </>
        )}

        <hr/>

        <br/>

        <div className="card">
            <h3>Host Information: </h3>
            <p><strong>Hotel Name:</strong> {listing.owner.hotel.name}</p>
            <p><strong>Hotel Owner Name:</strong> {listing.owner.full_name}</p>
            <p><strong>Email:</strong> {listing.owner.email}</p>
            <p><strong>Phone:</strong> {listing.owner.phone_number}</p>
        </div>

        <hr/>

        <h3>Reviews & Ratings: </h3>
        {listing.bookings?.filter(book => book.review && book.review.comment).length > 0 ? (
            listing.bookings.filter(book => book.review && book.review.comment).map((book, index) => (
            <div key={index} className="review-card" style={{ marginBottom: "12px", padding: "12px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>
                <p style={{ margin: "0 0 4px 0", fontWeight: "bold" }}>{book.user?.full_name || "Verified Guest"}</p>
                <p style={{ margin: "0 0 4px 0", color: "#f59e0b" }}>⭐ {book.review.rating || book.review.rating_type_id || 5} Stars - {book.review.ratingType?.name || "Verified Stay"}</p>
                <p style={{ margin: 0, fontStyle: "italic", color: "#475569" }}>"{book.review.comment}"</p>
            </div>
            ))
        ) : (
            <p>No reviews yet</p>
        )}
        </div>
        <Footer />
    </>
  );
};

export default PublicListing;
